// Author YuJiaBei
// Date 2020-12-02 16:57:54

//SAP连接地址热切换配置: key/value 由 SAP连接地址配置 页面维护, 系统参数页面只允许改名称和备注
const SAP_ADDRESS_CONFIG_KEY = 'sithMes.sap.address.config';
const SAP_ADDRESS_CONFIG_ROUTE = '/sithMes/mst/sapAddressConfig';
//命中这一条记录的条件: 用于按行禁用编辑(disabledWhen)和按行显示链接(linkWhen)
const SAP_ADDRESS_CONFIG_ROW_MATCH = {field: 'sysParameterKey', value: SAP_ADDRESS_CONFIG_KEY};

class EmAdmSysParam {
constructor({
        id = null,
        name = '',
        sysParameterKey = '',
        sysParameterValue = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.sysParameterKey = sysParameterKey;
    this.sysParameterValue = sysParameterValue;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmSysParam();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysParam.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sysParameterKey',
        label: 'label.em.admin.emAdmSysParam.grid.sysParameterKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sysParameterValue',
        label: 'label.em.admin.emAdmSysParam.grid.sysParameterValue',
        sortable: true,
        form: {
        type: 'textarea'
            //只有 SAP连接地址热切换配置 这一条的 value 可点击, 跳转到专用维护页面
            ,linkTo: 'route_link'
            ,linkRoute: SAP_ADDRESS_CONFIG_ROUTE
            ,linkWhen: SAP_ADDRESS_CONFIG_ROW_MATCH
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysParam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    sysParameterKeyFilter : "",
    sysParameterValueFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmSysParam.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterKeyFilter',
        label: 'label.em.admin.emAdmSysParam.filter.sysParameterKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterValueFilter',
        label: 'label.em.admin.emAdmSysParam.filter.sysParameterValue',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAdmSysParam.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterKey',
        label: 'label.em.admin.emAdmSysParam.entity.sysParameterKey',
        sortable: true,
        disabled: false,
            //SAP连接地址热切换配置: key 不允许修改
            disabledWhen: SAP_ADDRESS_CONFIG_ROW_MATCH,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sysParameterValue',
        label: 'label.em.admin.emAdmSysParam.entity.sysParameterValue',
        sortable: true,
        disabled: false,
            //SAP连接地址热切换配置: value 由 SAP连接地址配置 页面维护, 此处不允许修改
            disabledWhen: SAP_ADDRESS_CONFIG_ROW_MATCH,
        form: {
        type: 'textarea'
            //只有 SAP连接地址热切换配置 这一条的 value 可点击, 跳转到专用维护页面
            ,linkTo: 'route_link'
            ,linkRoute: SAP_ADDRESS_CONFIG_ROUTE
            ,linkWhen: SAP_ADDRESS_CONFIG_ROW_MATCH
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmSysParam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmSysParam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
